// Port of api/fuel/app/classes/filter/search/games/sorts/query/plays.php
import F from 'offline/filter/constants'
export default {
	name: '_plays_auto',
	post: false,
	require: function(config, filter) {
		return config.pseudoType === F.PSEUDO_PLAY && config.resultType === F.RESULT_PLAY
	},
	run: function(config, filter, data, query) {
		query.order('MAX(p.play_date)', true, 1010)
		query.order('MAX(p.play_id)', false, 1011)
	}
}
